module.exports = __webpack_public_path__ + "assets/img/stillrun_en.ed70e9d5.png";